import { useEffect, useState } from 'react';
import { getNativeCapabilities, isNativeMobile, type NativeCapabilities } from './nativeBridge';

export function useNativeCapabilities() {
  const [pending, setPending] = useState(isNativeMobile);
  const [capabilities, setCapabilities] = useState<NativeCapabilities | null>(null);
  useEffect(() => {
    let current = true;
    void getNativeCapabilities().then((result) => {
      if (current) { setCapabilities(result); setPending(false); }
    });
    return () => { current = false; };
  }, []);
  return { capabilities, pending };
}
